import { render, staticRenderFns } from "./ProblemClassification.vue?vue&type=template&id=6cd85c51&"
import script from "./ProblemClassification.vue?vue&type=script&lang=js&"
export * from "./ProblemClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports